import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TrainingPeriodForm from "./TrainingPeriodForm";
import { addTrainingPeriod } from "../../actions/trainingPeriodActions";
import { RootState } from "../../store/configureStore";
import TrainingPeriod from "../../types/TrainingPeriod";

const AddTrainingPeriod: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loggedInUser = useSelector((state: RootState) => state.loggedInUser);

  const [trainingPeriodData, setTrainingPeriodData] = useState<TrainingPeriod | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      setTrainingPeriodData({
        id: undefined,
        userId: loggedInUser.id,
        name: "",
        type: "CAMP",
        startDate: new Date(),
        endDate: new Date(),
      });
    }
  }, [loggedInUser]);

  const saveTrainingPeriodToDB = async (trainingPeriodToSave: TrainingPeriod) => {
    setIsSaving(true);
    try {
      await dispatch(addTrainingPeriod(trainingPeriodToSave) as any);
      navigate("/training-periods");
    } catch (error) {
      console.error("Error adding training period:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancel = () => {
    navigate("/training-periods");
  };

  if (!loggedInUser) {
    return <p>Please log in to add a training period.</p>;
  }

  if (isSaving) {
    return <p>Saving...</p>;
  }

  if (!trainingPeriodData) {
    return null;
  }

  return (
    <TrainingPeriodForm
      trainingPeriod={trainingPeriodData}
      onSave={saveTrainingPeriodToDB}
      onCancel={handleCancel}
    />
  );
};

export default AddTrainingPeriod;
